const kpi = {
  title: 'Estadística actual', 
};

export default kpi;